import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import { FC } from 'react';

import CountUp from '@/components/core/CountUp';
import Container from '@/components/elements/Container';
import Heading from '@/components/elements/Heading';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';
import TwoColumnStandard from '@/components/elements/StandardText/TwoColumnStandard';
import Text from '@/components/elements/Text';

export interface StatsProps {
  story: any;
  blok: any;
  pre_heading: string;
  heading: string;
  content: string;
  stats: any;
}

const Stats: FC<StatsProps> = ({ blok, stats = blok.stats }) => {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.25,
        delayChildren: 0.35,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 75,
        mass: 0.75,
        duration: 0.35,
      },
    },
  };

  return (
    <Section {...storyblokEditable(blok)} gapBottom="xl">
      <Container size="wider">
        <div
          id="stats"
          className="flex flex-col items-end gap-8 md:gap-12 lg:gap-16"
        >
          <div className="w-full flex-col items-end justify-start gap-24 md:flex md:flex-row">
            <TwoColumnStandard blok={blok} />
          </div>
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={container}
            id="stats-numbers"
            className="w-full md:flex"
          >
            {stats && (
              <dl className="flex w-full flex-col gap-12 md:flex-row">
                {stats.map((stat) => (
                  <motion.div
                    variants={item}
                    key={stat?._uid}
                    className={`flex flex-1 flex-col gap-2`}
                  >
                    <Text
                      size="lg"
                      color="black"
                      element="dt"
                      className={`font-semibold ${
                        stat.position === 'above' ? 'order-2' : 'order-1'
                      }`}
                    >
                      {stat.label}
                    </Text>
                    <Heading
                      size="md"
                      color="black"
                      element="dd"
                      className={`
                        font-medium text-theme-black leading-[0.85] tracking-tight
                        ${stat.position === 'above' ? 'order-1' : 'order-2'}`}
                    >
                      <CountUp number={stat.stat} />
                      {stat.suffex}
                    </Heading>
                    {stat.details && (
                      <div className="order-3">
                        <Prose size={'xs'} content={stat.details}></Prose>
                      </div>
                    )}
                  </motion.div>
                ))}
              </dl>
            )}
          </motion.div>
        </div>
      </Container>
    </Section>
  );
};

export default Stats;
